import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import LoginPage from './pages/LoginPage';
import RestaurantSelectionPage from './pages/RestaurantSelectionPage';
import TableSelectionPage from './pages/TableSelectionPage';
import QRMenuOrder from './pages/QRMenuOrder';
import TestPage from './pages/TestPage';
import OrdersPage from './pages/OrdersPage';
import PayBillPage from './pages/PayBillPage';
import './App.css';

function App() {
  return (
    <Router>
      <Toaster 
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          // Default options
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
            fontSize: '14px',
            padding: '12px 20px',
            borderRadius: '8px',
          },
          // Success style
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10B981',
              secondary: '#fff',
            },
            style: {
              background: '#10B981',
              color: '#fff',
            },
          },
          // Error style
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#EF4444',
              secondary: '#fff',
            },
            style: {
              background: '#EF4444',
              color: '#fff',
            },
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/select-restaurant" element={<RestaurantSelectionPage />} />
        <Route path="/tables" element={<TableSelectionPage />} />
        <Route path="/menu" element={<QRMenuOrder />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/pay-bill" element={<PayBillPage />} />
        <Route path="/test" element={<TestPage />} />
      </Routes>
    </Router>
  );
}

export default App;
